module.exports = __webpack_public_path__ + "static/media/Sign.d726ed16.jpeg";